<template>
  <b-collapse class="panel" :open.sync="isOpen">
    <div slot="trigger" class="panel-heading" role="button">
      <strong>{{ title }}</strong>
    </div>
    <div class="panel-block">
      <slot></slot>
    </div>
  </b-collapse>
</template>

<script>
export default {
  name: "collapse",
  props: {
    title: {
      type: String
    }
  },
  data() {
    return {
      isOpen: true
    };
  }
};
</script>
